module.exports = __webpack_public_path__ + "img/-LV19SYk5CP_LMOznVTl.6f2da8ba.jpg";